module.exports = __webpack_public_path__ + "img/default_thum.70d09295.png";